import { ConfirmAction, Heading, HeadingCaption } from 'idsk-react-components';
import React, { ReactElement } from 'react';
import { BackButton, BackLink } from 'slovlex-idsk-react-components';
import SuccessMessages from '../SuccessMessages';
import './pageHeadingWithBackButton.scss';

interface Props {
  heading?: string;
  headingCaption?: string;
  elementNextToHeading?: ReactElement;
  backLinkRoute?: string;
  backLinkText?: string;
  withBackLink?: boolean;
}

const PageHeadingWithBackButton = ({
  heading,
  headingCaption,
  elementNextToHeading,
  backLinkRoute,
  backLinkText,
  withBackLink = false,
}: Props): ReactElement => {
  function backButton(): ReactElement {
    if (withBackLink) {
      return (
        <BackButton buttonStyle="link" />
      );
    }

    if (backLinkText && backLinkRoute) {
      return (
        <BackLink to={backLinkRoute}>{backLinkText}</BackLink>
      );
    }

    return null;
  }

  return (
    <div className="vestniky-page-heading">
      <SuccessMessages />
      <ConfirmAction />
      {(backLinkText || withBackLink) && (
        <div className="back-button">
          {backButton()}
        </div>
      )}
      {headingCaption && (
        <HeadingCaption size="xl">{headingCaption}</HeadingCaption>
      )}
      {heading && (
        <div><Heading size="xl" className="page-title">{heading}</Heading>{elementNextToHeading}
        </div>
      )}
    </div>
  );
};

export default PageHeadingWithBackButton;
